import { FC } from 'react';

import { FormFieldArray } from '../../types';
import {
  isFormFieldArray,
  isFormFieldCheckbox,
  isFormFieldDate,
  isFormFieldDateRange,
  isFormFieldInput,
  isFormFieldNumber,
  isFormFieldSelect,
} from '../../utils';

import FormArrayRenderer from '../FormArrayRenderer';
import FormCheckBoxRenderer from '../FormCheckBoxRenderer';
import FormDateRangeRenderer from '../FormDateRangeRenderer';
import FormDateRenderer from '../FormDateRenderer';
import FormInputRenderer from '../FormInputRenderer';
import FormNumberRenderer from '../FormNumberRenderer';
import FormSelectRenderer from '../FormSelectRenderer';

import { Props } from './types';

const FormFieldRenderer: FC<Props> = ({ field }) => {
  if (isFormFieldArray(field)) {
    return <FormArrayRenderer arrayField={field as FormFieldArray} />;
  }
  if (isFormFieldInput(field)) {
    return <FormInputRenderer field={field} />;
  }
  if (isFormFieldNumber(field)) {
    return <FormNumberRenderer field={field} />;
  }
  if (isFormFieldCheckbox(field)) {
    return <FormCheckBoxRenderer field={field} />;
  }
  if (isFormFieldDate(field)) {
    return <FormDateRenderer field={field} />;
  }
  if (isFormFieldDateRange(field)) {
    return <FormDateRangeRenderer field={field} />;
  }
  if (isFormFieldSelect(field)) {
    return <FormSelectRenderer field={field} />;
  }

  return null;
};

export default FormFieldRenderer;
